<template>
	<div class="join">
		<el-dialog title="加入选品表" :width="width" :close-on-click-modal="false" :visible.sync="dialogJoinVisible" @close="resetForms()">
			<div class="tipsBox">
				<i class="el-icon-info yx-color-primary mr-4"></i>
				<span>您正在协助达人招商进行操作，本次操作将会同步到达人招商选品小程序中，请与相应达人招商确认后进行操作！</span>
			</div>
			<div class="product_box">
				<product-box :row="row"></product-box>
			</div>
			<div class="user_info_box mt-10" v-if="share_type === '0'">
				<user-info-box :row="row"></user-info-box>
			</div>
			<div slot="footer" class="dialog-footer" v-if="share_type === '0'">
				<el-button @click="dialogJoinVisible = false">取 消</el-button>
				<el-button type="primary" @click="joinConfirm">确认加入选品表</el-button>
			</div>
			<div class="user_info_box mt-10" v-if="share_type !== '0'">
				<div class="import-content pt-24">
					<el-steps :active="active" align-center>
						<el-step>
							<div slot="title" class="title">选择达人</div>
							<div slot="description">
								<div class="flex flex-align-center flex-just-center mt-20" v-if="active != 1">
									<daren-item :item="danRenObj" :platformId="platformId"></daren-item>
								</div>
								<p v-if="active == 1" class="desc">选择想要推品的达人</p>
							</div>
						</el-step>
						<el-step>
							<div slot="title" class="title">选择联系人</div>
							<div slot="description">
								<div class="flex flex-align-center flex-just-center mt-20" v-if="contactObj.id">
									<contact-item :item="contactObj"></contact-item>
								</div>
								<p class="desc" v-else>{{ state ? '绑定新的达人招商' : '仅选择的联系人才有权限查看商品' }}</p>
							</div>
						</el-step>
					</el-steps>
				</div>
				<div class="footer-select mt-30 flex flex-align-center">
					<el-form :model="danRenFrom" ref="danRenFrom" :rules="danRenRules">
						<el-form-item label="请选择 / 搜索达人" label-width="170px" prop="selectDaren" v-if="active == 1">
							<dr-select v-model="danRenFrom.selectDaren" :platformId="platformId" @change="drSelectChange"></dr-select>
						</el-form-item>
						<el-form-item label="请选择 / 搜索联系人" label-width="170px" prop="selectContact" v-if="active == 2">
							<dr-contact-select
								v-model="danRenFrom.selectContact"
								:anchorId="params.anchor_id"
								unbindWechat="0"
								@change="contactChange"
							></dr-contact-select>
						</el-form-item>
					</el-form>
					<p @click="skipCRM" v-if="active == 1" class="ml-10 des fz-12">{{ content }}</p>
				</div>
			</div>
			<span slot="footer" class="dialog-footer" v-if="share_type !== '0'">
				<el-button v-if="active == 2" @click="showLinkmanDialog">新建联系人</el-button>
				<el-button v-if="active == 1 || active == 3" @click="dialogJoinVisible = false">取消</el-button>
				<el-button type="primary" @click="nextStep">{{ active == 2 ? '加入选品表' : '下一步' }}</el-button>
			</span>
		</el-dialog>
		<linkman-dialog ref="linkmanDialog" />
		<repeat-cooperation ref="repeatCooperation" @directSend="joinSelection" />
	</div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import { addProduct, checkSendSampleOrder } from '@/api/shopManage';
import linkmanDialog from '@/views/talentCRM/components/linkmanDialog';
import DrSelect from '@/components/drSelect';
import DarenItem from '@/components/drSelect/item';
import DrContactSelect from '@/components/drContactSelect';
import ContactItem from '@/components/drContactSelect/item';
import repeatCooperation from '@/views/common/dialog/repeatCooperation.vue';
export default {
	name: 'join',
	components: {
		productBox,
		linkmanDialog,
		userInfoBox,
		DrSelect,
		DarenItem,
		DrContactSelect,
		ContactItem,
		repeatCooperation,
	},
	props: {
		isDisabled: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
		platform_id: {
			type: String,
			default: () => {
				return '1';
			},
		},
		isShowBtn: {
			type: Boolean,
			default: () => {
				return true;
			},
		},
	},
	data() {
		return {
			dialogJoinVisible: false,
			row: {},
			share_id: '',
			danRenFrom: {
				selectDaren: '',
				selectContact: '',
			},
			width: '45%',
			danRenObj: {},
			contactObj: {},
			danRenRules: {
				selectDaren: [{ required: true, message: '请选择达人', trigger: 'blur' }],
				selectContact: [{ required: true, message: '请选择联系人', trigger: 'blur' }],
			},
			active: 1,
			content: '没找到达人？去达人CRM添加',
			state: 0,
			params: {},
			platformId: '1',
			share_source: '',
			share_type: '',
		};
	},
	methods: {
		initJoin(row, id, type, share_type) {
			this.share_type = share_type;
			this.width = share_type == '0' ? '30%' : '45%';
			this.share_source = type;
			this.row = row;
			this.share_id = id;
			this.platformId = row.platform_id;
			this.dialogJoinVisible = true;
		},
		async joinConfirm() {
			let params = {
				product_id: this.row.product_id,
				share_id: this.share_id,
				share_source: this.share_source,
				anchor_id: this.row.anchor_id,
				contact_id: this.row.contact_id,
			};
			const { code } = await addProduct(params);
			if (code === 0) {
				this.$message.success('加入选品表成功');
				this.dialogJoinVisible = false;
			}
		},
		//下一步
		nextStep() {
			if (this.active == 1) {
				this.$refs['danRenFrom'].validate(async valid => {
					if (valid) {
						this.active = 2;
						this.params.anchor_id = this.danRenFrom.selectDaren;
						this.resetForms(1);
						this.danRenFrom = {
							selectDaren: '',
							selectContact: '',
						};
					}
				});
			} else if (this.active == 2) {
				this.$refs['danRenFrom'].validate(async valid => {
					if (valid) {
						const { product_id } = this.row;
						const { anchor_id } = this.params;
						const { code: code1, data: { type, status, partners = [], team_institution_infos = [] } = {} } = await checkSendSampleOrder({
							productIds: [product_id],
							anchorIds: [anchor_id],
						});
						if (code1 !== 0) return;
						if (!type) return this.joinSelection();
						this.$refs.repeatCooperation.show(type, 0, status, partners, team_institution_infos);
					}
				});
			}
		},
		async joinSelection() {
			let params = {
				product_id: this.row.product_id,
				share_id: this.share_id,
				share_source: this.share_source,
				anchor_id: this.params.anchor_id,
				contact_id: this.contactObj.id,
			};
			const { code } = await addProduct(params);
			if (code === 0) {
				this.$message.success('加入选品表成功');
				this.dialogJoinVisible = false;
			}
		},
		//重置弹框表单
		resetForms(value) {
			if (value) {
				this.$refs['danRenFrom'].resetFields();
			} else {
				if (this.share_type !== '0') {
					this.resetForm();
				}
			}
		},
		//重置表单
		resetForm() {
			this.active = 1;
			this.$refs['danRenFrom'].resetFields();
			this.danRenFrom = {
				selectDaren: '',
				selectContact: '',
			};
			this.danRenObj = {};
			this.contactObj = {};
		},
		// 跳转CRM
		skipCRM() {
			const handLink = this.$router.resolve({
				path: '/talentCRM',
				query: { platformId: this.platformId },
			});
			window.open(handLink.href, '_blank');
		},
		showLinkmanDialog() {
			const {
				danRenObj: { id: anchor_id, anchor_name, anchor_account, head },
				platform_id,
			} = this;
			const anchor_info = {
				anchor_name,
				anchor_account,
				head,
				platform_id,
			};
			this.$refs.linkmanDialog.show(
				{
					anchor_id,
					operate_time: Date.now(),
					is_pass: 1,
					contact_type: 1,
				},
				anchor_info,
				1,
			);
		},
		drSelectChange(val, obj) {
			this.danRenObj = { ...obj };
		},
		contactChange(val, obj) {
			this.contactObj = { ...obj };
		},
	},
};
</script>
<style lang="less" scoped>
.tipsBox {
	padding: 10px 16px;
	background-color: #e9f1ff;
	border: 1px solid #bdd5ff;
	margin-bottom: 10px;
}
.import-content {
	// background-color: #F8F8F8;
	.title {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #323233;
	}
	.desc {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: 18px;
	}
	.link {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #ee0a24;
		line-height: 18px;
	}
}
.result-content {
	.link {
		color: #1890ff;
	}
}
.add_contact {
	cursor: pointer;
}

/deep/.el-dialog__footer .link {
	margin-right: 10px;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #1890ff;
	line-height: 18px;
}
.footer-select {
	/deep/ .el-form-item {
		margin-bottom: 0px;
	}
	.des {
		border-bottom: 1px solid @color-primary;
	}
}
.footer-select p {
	cursor: pointer;
	color: @color-primary;
}
.join /deep/ .el-dialog__body {
	padding-top: 10px;
}
.join /deep/ .el-step__description {
	padding: 0px 0px;
}
/deep/ .el-select--small input {
	width: 260px;
}
</style>
